import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'integrationCapabilities',
  standalone: false,
})
export class IntegrationCapabilitiesPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: Record<string, boolean> | null | undefined): string {
    if (!value || typeof value !== 'object') {
      return '—';
    }

    const enabled = Object.entries(value)
      .filter(([, active]) => active === true)
      .map(([key]) => key);

    if (!enabled.length) {
      return this.translate.instant(
        'features.integrations.table.noCapabilities',
      );
    }

    return enabled
      .map(key => {
        const labelKey = `enums.integrationCapability.${key}`;
        const translated = this.translate.instant(labelKey);
        return translated === labelKey ? key : translated;
      })
      .join(', ');
  }
}
